export const distanceOptions = [0, 25, 50, 100, 200, 250];

export const stateOptions = [
  { value: 'AL', key: 'AL', text: 'Alabama' },
  { value: 'AK', key: 'AK', text: 'Alaska' },
  { value: 'AB', key: 'AB', text: 'Alberta' },
  { value: 'AS', key: 'AS', text: 'American Samoa' },
  { value: 'AZ', key: 'AZ', text: 'Arizona' },
  { value: 'AR', key: 'AR', text: 'Arkansas' },
  { value: 'BC', key: 'BC', text: 'British Columbia' },
  { value: 'CA', key: 'CA', text: 'California' },
  { value: 'CO', key: 'CO', text: 'Colorado' },
  { value: 'CT', key: 'CT', text: 'Connecticut' },
  { value: 'DE', key: 'DE', text: 'Delaware' },
  { value: 'DC', key: 'DC', text: 'District Of Columbia' },
  { value: 'FL', key: 'FL', text: 'Florida' },
  { value: 'GA', key: 'GA', text: 'Georgia' },
  { value: 'GU', key: 'GU', text: 'Guam' },
  { value: 'HI', key: 'HI', text: 'Hawaii' },
  { value: 'ID', key: 'ID', text: 'Idaho' },
  { value: 'IL', key: 'IL', text: 'Illinois' },
  { value: 'IN', key: 'IN', text: 'Indiana' },
  { value: 'IA', key: 'IA', text: 'Iowa' },
  { value: 'KS', key: 'KS', text: 'Kansas' },
  { value: 'KY', key: 'KY', text: 'Kentucky' },
  { value: 'LA', key: 'LA', text: 'Louisiana' },
  { value: 'ME', key: 'ME', text: 'Maine' },
  { value: 'MB', key: 'MB', text: 'Manitoba' },
  { value: 'MD', key: 'MD', text: 'Maryland' },
  { value: 'MA', key: 'MA', text: 'Massachusetts' },
  { value: 'MI', key: 'MI', text: 'Michigan' },
  { value: 'MN', key: 'MN', text: 'Minnesota' },
  { value: 'MS', key: 'MS', text: 'Mississippi' },
  { value: 'MO', key: 'MO', text: 'Missouri' },
  { value: 'MT', key: 'MT', text: 'Montana' },
  { value: 'NE', key: 'NE', text: 'Nebraska' },
  { value: 'NV', key: 'NV', text: 'Nevada' },
  { value: 'NB', key: 'NB', text: 'New Brunswick' },
  { value: 'NH', key: 'NH', text: 'New Hampshire' },
  { value: 'NJ', key: 'NJ', text: 'New Jersey' },
  { value: 'NM', key: 'NM', text: 'New Mexico' },
  { value: 'NY', key: 'NY', text: 'New York' },
  { value: 'NL', key: 'NL', text: 'Newfoundland and Labrador' },
  { value: 'NC', key: 'NC', text: 'North Carolina' },
  { value: 'ND', key: 'ND', text: 'North Dakota' },
  { value: 'MP', key: 'MP', text: 'Northern Mariana Islands' },
  { value: 'NS', key: 'NS', text: 'Nova Scotia' },
  { value: 'NU', key: 'NU', text: 'Nunavut' },
  { value: 'OH', key: 'OH', text: 'Ohio' },
  { value: 'OK', key: 'OK', text: 'Oklahoma' },
  { value: 'ON', key: 'ON', text: 'Ontario' },
  { value: 'OR', key: 'OR', text: 'Oregon' },
  { value: 'PA', key: 'PA', text: 'Pennsylvania' },
  { value: 'PE', key: 'PE', text: 'Prince Edward Island' },
  { value: 'PR', key: 'PR', text: 'Puerto Rico' },
  { value: 'QC', key: 'QC', text: 'Quebec' },
  { value: 'RI', key: 'RI', text: 'Rhode Island' },
  { value: 'SK', key: 'SK', text: 'Saskatchewan' },
  { value: 'SC', key: 'SC', text: 'South Carolina' },
  { value: 'SD', key: 'SD', text: 'South Dakota' },
  { value: 'TN', key: 'TN', text: 'Tennessee' },
  { value: 'TX', key: 'TX', text: 'Texas' },
  { value: 'UM', key: 'UM', text: 'US Minor Outlying Islands' },
  { value: 'UT', key: 'UT', text: 'Utah' },
  { value: 'VT', key: 'VT', text: 'Vermont' },
  { value: 'VI', key: 'VI', text: 'Virgin Islands' },
  { value: 'VA', key: 'VA', text: 'Virginia' },
  { value: 'WA', key: 'WA', text: 'Washington' },
  { value: 'WV', key: 'WV', text: 'West Virginia' },
  { value: 'WI', key: 'WI', text: 'Wisconsin' },
  { value: 'WY', key: 'WY', text: 'Wyoming' },
];

export const studentBodySizesList = [
  { value: 'VERY_LARGE', key: 'VERY_LARGE', text: 'Very large (Over 20,000 students)' },
  { value: 'LARGE', key: 'LARGE', text: 'Large (13,001 to 20,000 students)' },
  { value: 'MID_SIZE', key: 'MID_SIZE', text: 'Mid-Size (7,001 to 13,000 students)' },
  { value: 'MEDIUM', key: 'MEDIUM', text: 'Medium (4,001 to 7,000 students)' },
  { value: 'SMALL', key: 'SMALL', text: 'Small (2,001 to 4,000 students)' },
  { value: 'VERY_SMALL', key: 'VERY_SMALL', text: 'Very Small (2,000 or fewer students)' },
];
